/* Recherche locale à la page : ouverture au survol, résultats Shopify paginés. */
(function () {
  document.querySelectorAll('[data-entete]').forEach(function (entete) {
    var panneau = entete.querySelector('[data-recherche-bandeau]');
    if (!panneau || panneau.hasAttribute('data-pret')) return;
    panneau.setAttribute('data-pret', '');
    var boutons = Array.from(entete.querySelectorAll('[data-ouvre-recherche]'));
    var form = panneau.querySelector('form');
    var champ = form.querySelector('input[name="q"]');
    var etat = panneau.querySelector('[data-recherche-etat]');
    var resultats = panneau.querySelector('[data-recherche-resultats]');
    var ouvreur, fermeture, saisie, controle, generation = 0;
    function annuler() {
      clearTimeout(saisie); generation++;
      if (controle) controle.abort();
      resultats.removeAttribute('aria-busy');
    }
    function fermer(retour) {
      clearTimeout(fermeture); annuler(); panneau.hidden = true;
      boutons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (retour || panneau.contains(document.activeElement)) {
        var cible = ouvreur && ouvreur.getClientRects().length ? ouvreur : boutons.find(function (b) { return b.getClientRects().length; });
        if (cible) cible.focus();
      }
    }
    function ouvrir(b, focus) {
      var etaitFerme = panneau.hidden;
      clearTimeout(fermeture); ouvreur = b;
      var mobile = entete.querySelector('[data-menu-mobile]');
      if (mobile && !mobile.hidden) mobile.querySelector('[data-ferme-menu]').click();
      entete.dispatchEvent(new CustomEvent('chanoyu:recherche-ouverte'));
      panneau.hidden = false;
      boutons.forEach(function (x) { x.setAttribute('aria-expanded', 'true'); });
      if (focus) champ.focus();
      if (etaitFerme && champ.value.trim().length >= 2 && !resultats.children.length) chercher();
    }
    boutons.forEach(function (b) {
      b.hidden = false;
      b.addEventListener('mouseenter', function () {
        if (!b.closest('[data-menu-mobile]') && window.matchMedia('(min-width: 990px) and (hover: hover)').matches) ouvrir(b, false);
      });
      b.addEventListener('click', function () { ouvrir(b, true); });
      b.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); ouvrir(b, true); } });
    });
    panneau.addEventListener('mouseenter', function () { clearTimeout(fermeture); });
    panneau.addEventListener('focusin', function () { clearTimeout(fermeture); });
    entete.addEventListener('mouseleave', function () {
      fermeture = setTimeout(function () { if (!panneau.contains(document.activeElement)) fermer(false); }, 200);
    });
    entete.addEventListener('focusout', function () {
      setTimeout(function () { if (!panneau.hidden && !entete.contains(document.activeElement)) fermer(false); }, 0);
    });
    entete.addEventListener('chanoyu:menu-ouvert', function () { fermer(false); });
    var menu = entete.querySelector('[data-ouvre-menu]');
    if (menu) menu.addEventListener('click', function () { fermer(false); });
    panneau.querySelector('[data-ferme-recherche]').addEventListener('click', function () { fermer(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panneau.hidden) { e.preventDefault(); fermer(true); } });
    document.addEventListener('click', function (e) { if (!panneau.hidden && !panneau.contains(e.target) && !e.target.closest('[data-ouvre-recherche]')) fermer(false); });

    function chercher(href, focusResultats) {
      annuler();
      var texte = champ.value.trim();
      resultats.replaceChildren();
      if (texte.length < 2) { etat.textContent = 'Saisissez au moins deux caractères.'; return; }
      var url = new URL(href || form.getAttribute('action'), window.location.href);
      if (url.origin !== new URL(window.location.href).origin) return;
      if (!href) url.searchParams.set('q', texte);
      url.searchParams.set('section_id', 'recherche-bandeau-resultats');
      var numero = generation;
      controle = new AbortController();
      var actif = controle;
      var delai = setTimeout(function () { actif.abort(); }, 12000);
      etat.textContent = 'Recherche en cours…';
      resultats.setAttribute('aria-busy', 'true');
      fetch(url.href, { credentials: 'same-origin', signal: actif.signal }).then(function (r) {
        if (!r.ok) throw new Error('Recherche indisponible');
        return r.text();
      }).then(function (html) {
        if (numero !== generation || panneau.hidden) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var contenu = doc.querySelector('[data-recherche-reponse]');
        if (!contenu) throw new Error('Réponse absente');
        contenu.querySelectorAll('script').forEach(function (s) { s.remove(); });
        etat.textContent = contenu.querySelector('[data-recherche-compte]').textContent;
        resultats.replaceChildren(contenu);
        if (focusResultats) { resultats.setAttribute('tabindex', '-1'); resultats.focus(); }
      }).catch(function () {
        if (numero === generation && !panneau.hidden) etat.textContent = 'La recherche n’a pas abouti. Réessayez avec Chercher.';
      }).finally(function () { clearTimeout(delai); if (numero === generation) resultats.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); chercher(); });
    function programmer() {
      annuler(); resultats.replaceChildren();
      if (champ.value.trim().length < 2) { etat.textContent = 'Saisissez au moins deux caractères.'; return; }
      etat.textContent = 'Recherche en cours…';
      saisie = setTimeout(function () { chercher(); }, 250);
    }
    champ.addEventListener('input', function (e) { if (!e.isComposing) programmer(); });
    champ.addEventListener('compositionend', programmer);
    resultats.addEventListener('click', function (e) {
      var lien = e.target.closest('[data-recherche-pagination] a');
      if (lien) { e.preventDefault(); chercher(lien.getAttribute('href'), true); }
    });
  });
})();
